import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from 'react';
import { Animated, Easing, Platform, View } from 'react-native';
import { CoreConfig } from './../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
function createRotation(baseStyle, animation) {
    return Object.assign(Object.assign({}, baseStyle), { transform: [
            ...((baseStyle === null || baseStyle === void 0 ? void 0 : baseStyle.transform) || []),
            {
                rotate: animation.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['0deg', '360deg']
                })
            }
        ] });
}
const loaderOutsideCircle = '#3498db';
const loaderMiddleCircle = '#e74c3c';
const loaderInsideCircle = '#f9c922';
export const LoadingView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.loading,
    style: {
        container: {},
        content: {
            justifyContent: 'center',
            alignItems: 'center',
            width: 50,
            height: 50,
        },
        loaderTop: {
            position: 'absolute',
            width: 50,
            height: 50,
            borderRadius: 50,
            borderWidth: 2,
            borderStyle: 'solid',
            borderBottomColor: '#fff',
            borderLeftColor: '#fff',
            borderRightColor: '#fff',
            borderTopColor: loaderOutsideCircle
        },
        loaderMiddle: {
            position: 'absolute',
            width: 43,
            height: 43,
            borderRadius: 43,
            borderStyle: 'solid',
            borderWidth: 2,
            borderBottomColor: '#fff',
            borderLeftColor: '#fff',
            borderRightColor: '#fff',
            borderTopColor: loaderMiddleCircle
        },
        loaderBottom: {
            position: 'absolute',
            width: 36,
            height: 36,
            borderRadius: 36,
            borderStyle: 'solid',
            borderWidth: 2,
            borderBottomColor: '#fff',
            borderLeftColor: '#fff',
            borderRightColor: '#fff',
            borderTopColor: loaderInsideCircle
        }
    }
})(({ style, containerStyle, children }) => {
    const loaderTopAnimation = useRef(new Animated.Value(0)).current;
    const loaderMiddleAnimation = useRef(new Animated.Value(0)).current;
    const loaderBottomAnimation = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        const useNativeDriver = Platform.OS !== 'web';
        Animated.parallel([
            Animated.loop(Animated.timing(loaderTopAnimation, {
                duration: 1000,
                toValue: 1,
                easing: Easing.linear,
                useNativeDriver
            })),
            Animated.loop(Animated.timing(loaderMiddleAnimation, {
                duration: 700,
                toValue: 1,
                easing: Easing.linear,
                useNativeDriver
            })),
            Animated.loop(Animated.timing(loaderBottomAnimation, {
                duration: 500,
                toValue: 1,
                easing: Easing.linear,
                useNativeDriver
            }))
        ]).start();
    }, []);
    const loaderTop = useMemo(() => createRotation(style === null || style === void 0 ? void 0 : style.loaderTop, loaderTopAnimation), [style === null || style === void 0 ? void 0 : style.loaderTop]);
    const loaderMiddle = useMemo(() => createRotation(style === null || style === void 0 ? void 0 : style.loaderMiddle, loaderMiddleAnimation), [style === null || style === void 0 ? void 0 : style.loaderMiddle]);
    const loaderBottom = useMemo(() => createRotation(style === null || style === void 0 ? void 0 : style.loaderBottom, loaderBottomAnimation), [style === null || style === void 0 ? void 0 : style.loaderBottom]);
    return (_jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.container, containerStyle], children: [_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.content, children: [_jsx(Animated.View, { style: loaderTop }), _jsx(Animated.View, { style: loaderMiddle }), _jsx(Animated.View, { style: loaderBottom })] }), children || undefined] }));
});
